import { GetLastProductVersionsUseCaseInterface } from 'domain/usecases';
import { FRONT_END_APP } from 'domain/value-objects/front-end-app.enum';
import { SOFTWARE_ENVIRONMENT } from 'domain/value-objects/software-environment.enum';
import { WithChildren } from 'presentation/config/helpers/react18MigrationHelpers';
import { createContext, useCallback, useState, useEffect, FC } from 'react';

import { useService } from '../hooks/useService';
import { getEnv } from 'shared/get-env';

interface ProductVersionsContextProps {
  frontVersion?: string;
  apiVersion?: string;
}

const initProductVersionsContextPropsState: ProductVersionsContextProps = {
  frontVersion: undefined,
  apiVersion: undefined,
};

export const ProductVersionsContext =
  createContext<ProductVersionsContextProps>(
    initProductVersionsContextPropsState,
  );

export const ProductVersionsProvider: FC<WithChildren> = ({ children }) => {
  const [frontVersion, setFrontVersion] = useState<string | undefined>(
    undefined,
  );
  const [apiVersion, setApiVersion] = useState<string | undefined>(undefined);
  const { commonUtilsService } = useService();

  const requestGetLastProductVersions = useCallback(
    async ({
      frontApp,
      env,
    }: GetLastProductVersionsUseCaseInterface.Params) => {
      commonUtilsService
        .getLastProductVersions({
          frontApp,
          env,
        })
        .then((response) => {
          setFrontVersion(response.frontVersion);
          setApiVersion(response.apiVersion);
        })
        .catch(() => {
          setFrontVersion(undefined);
          setApiVersion(undefined);
        });
    },
    [commonUtilsService],
  );

  useEffect(() => {
    requestGetLastProductVersions({
      frontApp: FRONT_END_APP.GESTOR,
      env:
        getEnv('REACT_APP_SOFTWARE_ENVIRONMENT') === 'PROD'
          ? SOFTWARE_ENVIRONMENT.PROD
          : SOFTWARE_ENVIRONMENT.STG,
    });
  }, [requestGetLastProductVersions]);

  return (
    <ProductVersionsContext.Provider
      value={{
        frontVersion,
        apiVersion,
      }}
    >
      {children}
    </ProductVersionsContext.Provider>
  );
};
